import DomManipulate from './DomManipulate';

export default class LazyloadImg {
    constructor(selector, listener, attrImageId) {
        this.selector = selector;
        this.listener = listener;
        this.attrImageId = attrImageId
        this.dom = new DomManipulate();
    }

    init() {
        this.dom.onReady(() => {
            this.onHoverReplaceSrcImg()
        })
    }

    onHoverReplaceSrcImg() {
        let arrayOfListener = document.querySelectorAll('[' + this.listener + ']')
        let arrayOfImg = document.querySelectorAll(this.selector);

        if (!arrayOfListener) {
            return
        }

        for (let i = 0; i < arrayOfListener.length; i++) {

            arrayOfListener[i].addEventListener("mouseenter", () => {

                let listernerId = arrayOfListener[i].getAttribute(this.listener);

                for (let x = 0; x < arrayOfImg.length; x++) {

                    let imgId = arrayOfImg[x].getAttribute(this.attrImageId);

                    if (imgId === listernerId) {

                        arrayOfImg[x].setAttribute("src", arrayOfImg[x].getAttribute("data-src"));

                    }

                }

            })
        }

    }

    onClickReplaceSrcImg() {

        this.dom.onReady(() => {

            let listener = document.querySelector(this.listener)
            let arrayOfImg = document.querySelectorAll(this.selector);

            if (!listener) {
                return
            }

            listener.addEventListener("click", () => {

                for (let x = 0; x < arrayOfImg.length; x++) {
                    arrayOfImg[x].setAttribute("src", arrayOfImg[x].getAttribute("data-src"));
                }

            })
        })
    }
};
